export default __webpack_public_path__ + "static/media/profile-large.7570c0df.jpg";